import { AvatarProfile } from "components/AvatarProfile";
import { TwitterIcon } from "components/library/Icons";
import { classNames } from "components/library/utils/classNames";
import Link from "next/link";
import React from "react";

const testimonials: TestimonialCardProps[] = [
  {
    name: "Amélie Chatelain",
    company: "LightOn",
    image: "/assets/customers/amelie-lighton.jpeg",
    href: "https://www.lighton.ai/",
    quote: (
      <p>
        Humanloop has been invaluable for evaluating our models — the direct,
        quantitative metrics aligned with human judgments have guided us to
        maximize model performance!
      </p>
    ),
  },
  {
    name: "Cherian Koshy",
    company: "Founder NonProfitOS",
    image: "/assets/customers/cherian-nonprofitos.jpeg",
    href: "https://nonprofitoperatingsystem.com/",
    quote: (
      <>
        <p>
          I was searching for a solution to differentiate ourselves from vanilla
          applications that didn't focus on the specific needs of our sector.
          Humanloop is a must-have resource.
        </p>
      </>
    ),
  },
  {
    name: "Aman Sanger",
    company: "Cursor AI",
    image: "/assets/customers/aman-cursor.jpeg",
    href: "https://www.cursor.so/",
    quote: (
      <p>
        Humanloop has been great for monitoring how users are invoking Cursor.
        This is useful for tailoring the product in a direction that best
        supports common use-cases.
      </p>
    ),
  },

  {
    name: "Michael Slade",
    company: "Retain.it",
    image: "/assets/customers/michael-retainit.jpeg",
    href: "https://retainit.app/",
    quote: (
      <>
        <p>
          This allows us to achieve a level of sophistication with GPT-3 that
          would otherwise be impossible.
        </p>
      </>
    ),
  },
  {
    name: "Chris Dossman",
    company: "Founder FAQx",
    image: "/assets/customers/chris-faqx.jpeg",
    href: "https://faqx.com/",
    quote: (
      <>
        <p>
          Been using Humanloop for a while and it really helps us build our LLM
          applications. Their one-click finetuning pipeline is great.
        </p>
      </>
    ),
  },
  {
    name: "John Shahawy",
    company: "Moonbeam",
    image: "/assets/customers/john-moonbeam.jpeg",
    href: "http://gomoonbeam.com/",
    quote: (
      <>
        Humanloop helped us ship and scale to thousands of DAUs. Version
        management, A/B testing prompts and fine tuning have been game changers.
      </>
    ),
  },
];

interface TestimonialCardProps {
  name: string;
  company: string;
  href?: string;
  image: string;
  quote: string | JSX.Element;
}

const TestimonialCard = ({
  name,
  company,
  href,
  image,
  quote,
}: TestimonialCardProps): JSX.Element => {
  return (
    <Link href={href as string} target="_blank" className="focus:outline-none">
      <div
        className={classNames(
          " h-full bg-white",
          "flex w-full max-w-full flex-col justify-start gap-16 rounded border border-gray-300 p-24 ",
          href ? "hover:border-gray-400 hover:bg-gray-100" : ""
        )}
      >
        <div className="mb-2 flex items-center justify-between gap-x-24">
          <AvatarProfile name={name} image={image} company={company} />
          {/* <div>
          <TwitterIcon color="#009ef7" />
        </div> */}
        </div>
        <span className="text-16-24 text-gray-800">{quote}</span>
      </div>
    </Link>
  );
};

export const TestimonialsSection = () => {
  return (
    <div className="bg-[#3333CB] px-24 pt-[80px] pb-[80px] dark:text-white  xl:px-[90px]">
      <div className="container-lg prose-dark">
        <h3 className="mb-40 text-center font-display text-[32px] font-normal leading-[36px] ">
          Loved by a community of entrepreneurs and developers
        </h3>
        <div className="md:grid-3 md:justify-items-none grid-1 justify-items-center gap-24 overflow-auto lg:grid-rows-2">
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.name} {...testimonial} />
          ))}
        </div>
      </div>
    </div>
  );
};
